import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { SaveCustomerMission } from '../../../store/actions/customer-mission.actions';
import { CustomerInterface } from '../../../../account/models/customer.interface';
import { CustomerStorageService } from '../../../../account/services/customer-storage.service';
import * as FileSaver from 'file-saver';
import { environment } from '../../../../../../environments/environment';
import { PaymentsService } from '../../../../payments/services/payments.service';

@Component({
  selector: 'app-generate-sepa-mandate',
  templateUrl: './generate-sepa-mandate.component.html',
  styleUrls: ['./generate-sepa-mandate.component.css'],
  standalone: false
})
export class GenerateSepaMandateComponent implements OnInit {

  @Input()
  procedureCode: string;
  sepa?: Blob;
  customer: CustomerInterface;
  formSubmitted: boolean;
  brand?: string;

  constructor(
      private store: Store<any>,
      private customerStorage: CustomerStorageService,
      private paymentsService: PaymentsService,
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.customer = this.customerStorage.getCustomer();
    this.formSubmitted = false;
    this.sepa = null;
    this.paymentsService.downloadSepa(this.customer.hashSepa).subscribe(
        response => {
          this.sepa = response;
        }
    );
  }

  downloadSepa() {
    FileSaver.saveAs(new Blob([this.sepa], {type: 'application/pdf'}), 'mandat_sepa.pdf');
  }

  save() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(
          new SaveCustomerMission({
            step: 1,
            customerId: this.customer.id,
          }, this.procedureCode, 'account'));
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }
}
